import { render } from "./ContactUs.vue?vue&type=template&id=572328a2&scoped=true&lang=pug"
import script from "./ContactUs.vue?vue&type=script&lang=ts"
export * from "./ContactUs.vue?vue&type=script&lang=ts"

import "./ContactUs.vue?vue&type=style&index=0&id=572328a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-572328a2"

export default script